import { render, staticRenderFns } from "./istarshine-view.vue?vue&type=template&id=6dc0c4c2"
import script from "./istarshine-view.vue?vue&type=script&lang=js"
export * from "./istarshine-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports